module.exports = __webpack_public_path__ + "img/back_of_book.bbf0d6d4.png";